import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {ToastService} from "../services/toast.service";
import {KEEP_TOAST} from "../utils/http-context-tokens";

export const clearToastInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);

  // Background requests opt out: they must not wipe a message the user is
  // still reading.
  if (!req.context.get(KEEP_TOAST)) {
    toastService.clear();
  }

  return next(req);
};
